import {
    GET_COMPANY_TYPE_DEF,
    GET_COMPANY_TYPE_DEF_SUCCESS,
    ADD_COMPANY_TYPE_DEF,
    ADD_COMPANY_TYPE_DEF_SUCCESS,
    UPDATE_COMPANY_TYPE_DEF,
    UPDATE_COMPANY_TYPE_DEF_SUCCESS,
    DELETE_COMPANY_TYPE_DEF,
    DELETE_COMPANY_TYPE_DEF_SUCCESS,
    COMPANY_TYPE_DEF_API_ERROR,
  
  } from "./actionTypes"
  
  
  export const getCompanyTypeDef = () => ({
    type: GET_COMPANY_TYPE_DEF,
  })
  
  export const getCompanyTypeDefSuccess = record => ({
    type: GET_COMPANY_TYPE_DEF_SUCCESS,
    payload: record,
  })
  
  export const addCompanyTypeDef = record => ({
    type: ADD_COMPANY_TYPE_DEF,
    payload: record,
  })
  
  export const addCompanyTypeDefSuccess = record => ({
    type: ADD_COMPANY_TYPE_DEF_SUCCESS,
    payload: record,
  })
  
  
  export const updateCompanyTypeDef = record => ({
    type: UPDATE_COMPANY_TYPE_DEF,
    payload: record,
  })
  
  export const updateCompanyTypeDefSuccess = record => ({
    type: UPDATE_COMPANY_TYPE_DEF_SUCCESS,
    payload: record,
  })

  export const deleteCompanyTypeDef = guid => ({
    type: DELETE_COMPANY_TYPE_DEF,
    payload: guid,
  })
  
  export const deleteCompanyTypeDefSuccess = guid => ({
    type: DELETE_COMPANY_TYPE_DEF_SUCCESS,
    payload: guid,
  })
  
  export const companyTypeDefApiError = error => {
    return {
      type: COMPANY_TYPE_DEF_API_ERROR,
      payload: error,
    }
  }
  